/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Components_Selleroffers_Morefrom2Inputs */

const id_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lainnya dari ${i?.name}`)
};

const ms_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lagi dari ${i?.name}`)
};

const da_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mere fra ${i?.name}`)
};

const de_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mehr von ${i?.name}`)
};

const en_us2_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More from ${i?.name}`)
};

const es_es2_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Más de ${i?.name}`)
};

const es_mx2_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Más de ${i?.name}`)
};

const fil_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Higit pa mula kay ${i?.name}`)
};

const fr_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus de ${i?.name}`)
};

const it_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Altro da ${i?.name}`)
};

const hu_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Több tőle: ${i?.name}`)
};

const nl_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meer van ${i?.name}`)
};

const no_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mer fra ${i?.name}`)
};

const pl_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Więcej od ${i?.name}`)
};

const pt_br2_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More from ${i?.name}`)
};

const pt_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mais de ${i?.name}`)
};

const ro_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mai multe de la ${i?.name}`)
};

const fi_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lisää myyjältä ${i?.name}`)
};

const sv_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mer från ${i?.name}`)
};

const vi_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thêm từ ${i?.name}`)
};

const tr_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} adlı satıcıdan daha fazlası`)
};

const cs_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Další od ${i?.name}`)
};

const bg_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Още от ${i?.name}`)
};

const ru_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ещё от ${i?.name}`)
};

const uk_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Більше від ${i?.name}`)
};

const ar_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`المزيد من ${i?.name}`)
};

const hi_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} से और अधिक`)
};

const th_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เพิ่มเติมจาก ${i?.name}`)
};

const ja_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の他の作品`)
};

const zh_cn2_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More from ${i?.name}`)
};

const zh_hant1_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More from ${i?.name}`)
};

const ko_components_selleroffers_morefrom2 = /** @type {(inputs: Components_Selleroffers_Morefrom2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More from ${i?.name}`)
};

/**
* | output |
* | --- |
* | "More from {name}" |
*
* @param {Components_Selleroffers_Morefrom2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_selleroffers_morefrom2 = /** @type {((inputs: Components_Selleroffers_Morefrom2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Selleroffers_Morefrom2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_selleroffers_morefrom2(inputs)
	if (locale === "ms") return ms_components_selleroffers_morefrom2(inputs)
	if (locale === "da") return da_components_selleroffers_morefrom2(inputs)
	if (locale === "de") return de_components_selleroffers_morefrom2(inputs)
	if (locale === "en-US") return en_us2_components_selleroffers_morefrom2(inputs)
	if (locale === "es-ES") return es_es2_components_selleroffers_morefrom2(inputs)
	if (locale === "es-MX") return es_mx2_components_selleroffers_morefrom2(inputs)
	if (locale === "fil") return fil_components_selleroffers_morefrom2(inputs)
	if (locale === "fr") return fr_components_selleroffers_morefrom2(inputs)
	if (locale === "it") return it_components_selleroffers_morefrom2(inputs)
	if (locale === "hu") return hu_components_selleroffers_morefrom2(inputs)
	if (locale === "nl") return nl_components_selleroffers_morefrom2(inputs)
	if (locale === "no") return no_components_selleroffers_morefrom2(inputs)
	if (locale === "pl") return pl_components_selleroffers_morefrom2(inputs)
	if (locale === "pt-BR") return pt_br2_components_selleroffers_morefrom2(inputs)
	if (locale === "pt") return pt_components_selleroffers_morefrom2(inputs)
	if (locale === "ro") return ro_components_selleroffers_morefrom2(inputs)
	if (locale === "fi") return fi_components_selleroffers_morefrom2(inputs)
	if (locale === "sv") return sv_components_selleroffers_morefrom2(inputs)
	if (locale === "vi") return vi_components_selleroffers_morefrom2(inputs)
	if (locale === "tr") return tr_components_selleroffers_morefrom2(inputs)
	if (locale === "cs") return cs_components_selleroffers_morefrom2(inputs)
	if (locale === "bg") return bg_components_selleroffers_morefrom2(inputs)
	if (locale === "ru") return ru_components_selleroffers_morefrom2(inputs)
	if (locale === "uk") return uk_components_selleroffers_morefrom2(inputs)
	if (locale === "ar") return ar_components_selleroffers_morefrom2(inputs)
	if (locale === "hi") return hi_components_selleroffers_morefrom2(inputs)
	if (locale === "th") return th_components_selleroffers_morefrom2(inputs)
	if (locale === "ja") return ja_components_selleroffers_morefrom2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_selleroffers_morefrom2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_selleroffers_morefrom2(inputs)
	return ko_components_selleroffers_morefrom2(inputs)
});
export { components_selleroffers_morefrom2 as "components.sellerOffers.moreFrom" }